import { Fulfillment } from "@secondcloset/types";
import { getAPIFromDomain } from "../../lib/api";

export type WorkOrder = {
  id: string;
  status: Fulfillment.ShippingMethodStatus;
  fulfillment_order_id: string;
  logistics_request_id: string;
  packages: Package[];
};

export type Package = {
  id: string;
  status: Fulfillment.PackageStatus;
  tracking_number: string;
  work_order_id: string;
};

export type WorkOrderQuery = {
  order_id: string;
  with_packages: boolean;
};

export const fetchWorkOrders = async (query: WorkOrderQuery): Promise<WorkOrder[]> => {
  const api = getAPIFromDomain("fulfillment");
  const url = `/work_orders`;
  const res = await api.get(url, {
    params: query,
  });
  return res.data.data;
};

export const refreshWorkOrder = async (id: string): Promise<WorkOrder> => {
  const api = getAPIFromDomain("fulfillment");
  const url = `/work_orders/${id}/refresh`;
  const res = await api.post(url);
  return res.data.data;
};
